module.exports = __webpack_public_path__ + "static/Beryl-c55eef0ec7797320a94c913317453c53.png";